<template>
  <b-modal
    ref="partnershipTermsModal"
    hide-footer
    title="Partnership Terms of Service"
    centered
    lazy
    scrollable
    @hide="hideModal"
    :size="size"
  >
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div class="mb-2">
          <b-skeleton width="60%"></b-skeleton>
          <b-skeleton width="80%"></b-skeleton>
        </div>
      </template>

      <div class="d-flex align-items-start">
        <div v-safe-html="school.partnership_terms" />
      </div>
    </b-skeleton-wrapper>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'PartnershipTermsModal',

  props: {
    showModal: { type: Boolean, default: false },
    size: { type: String, default: 'lg' },
    school: { type: Object, default: () => {} },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },

  watch: {
    showModal(value) {
      if (value) {
        this.$refs.partnershipTermsModal.show();
      }
    },
  },

  methods: {
    hideModal() {
      this.$emit('close');
    },

    hideModalManual() {
      this.$refs.partnershipTermsModal.hide();
      this.hideModal();
    },
  },

  async mounted() {},
};
</script>
